<template>
    <v-card>
        <v-card-text>
            <table x:str border="0" cellpadding="2" style="border-collapse: collapse; margin-left: 0; margin-right: 2"
                height="450" width="730">
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <b>
                            <font face="Arial" color="#666666" size="4">DOCUMENTOS
                                DEL SGI MÁS UTILIZADOS POR INGENIERÍA DE OBRA</font>
                        </b>
                    </td>
                </tr>
                <tr height="39" style="height: 29.25pt">
                    <td
                        style="height: 11; width: 728; font-size: 11.0pt; font-family: 'Times New Roman', serif; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; text-align: general; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        <img border="0" src="../../../public/images/DOCSGI.jpg" width="868" height="160">
                    </td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;PROCEDIMIENTOS</font>
                    </td>
                </tr>
                <tr v-for="item in procedimientos" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;INSTRUCCIONES</font>
                    </td>
                </tr>
                <tr v-for="item in instrucciones" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;ASIGNACIÓN DE FUNCIONES</font>
                    </td>
                </tr>
                <tr v-for="item in funciones" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;FORMULARIOS</font>
                    </td>
                </tr>
                <tr v-for="item in formularios" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
                <tr>
                    <td
                        style="height: 19; width: 728; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; font-style: normal; text-decoration: none; vertical-align: bottom; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px">
                        &nbsp;</td>
                </tr>
                <tr>
                    <td style="height: 23; color: white; font-size: 11.0pt; font-weight: 700; font-family: Arial, sans-serif; text-align: left; vertical-align: middle; font-style: normal; text-decoration: none; white-space: nowrap; border: medium none; padding-left: 1px; padding-right: 1px; padding-top: 1px; background: green"
                        width="728">
                        <font size="3">&nbsp;MANUALES</font>
                    </td>
                </tr>
                <tr v-for="item in manuales" :key="item.codigo" height="39" style="height: 29.25pt">
                    <td
                        style="height: 36px; width: 728px; font-size: 11.0pt; font-family: Arial, sans-serif; text-align: left; white-space: normal; color: windowtext; font-weight: 400; vertical-align: bottom; border: none; padding: 1px">
                        <font size="3">
                            &nbsp;
                            <a :href="`https://api.icssa.com.ar/SGI/Documentos/${item.codigo}.pdf?` + Math.random()"
                                target="_blank">
                                {{ item.codigo }}:
                            </a>
                            {{ item.descripcion }}.
                        </font>
                    </td>
                </tr>
            </table>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "ListaInstrucciones",
    data() {
        return {
            procedimientos: [
                { "codigo": "MP5.01.02", "descripcion": "Objetivos y metas" },
                { "codigo": "MP5.03.04", "descripcion": "Evaluación del impacto ambiental" },
                { "codigo": "MP5.04.03", "descripcion": "Programa SOL" },
                { "codigo": "MP6.02.01", "descripcion": "Gestión de recursos humanos" },
                { "codigo": "MP7.01.01", "descripcion": "Planificación de la realización del producto" },
                { "codigo": "MP7.01.02", "descripcion": "Organización, ejecución y verificación del servicio posventa" },
                { "codigo": "MP7.02.01", "descripcion": "Procesos relacionados con el cliente" },
                { "codigo": "MP7.03.01", "descripcion": "Diseño y desarrollo" },
                { "codigo": "MP7.04.01", "descripcion": "Gestión de compras" },
                { "codigo": "MP7.04.02", "descripcion": "Evaluación de subcontratistas y proveedores" },
                { "codigo": "MP7.04.03", "descripcion": "Norma interna para subcontratistas" },
                { "codigo": "MP8.01.01", "descripcion": "Requisitos generales para la medición, análisis y mejora" },
                { "codigo": "MP8.02.04", "descripcion": "Medición y seguimiento del producto" },
                { "codigo": "MP8.03.01", "descripcion": "Gestión de no conformidades" },
                { "codigo": "MP8.04.01", "descripcion": "Control de gestión" },
                { "codigo": "MP8.04.02", "descripcion": "Análisis de datos. Identificación y uso de técnicas estadísticas" },
                { "codigo": "MP8.05.01", "descripcion": "Gestión de mejoras. Sugerencias de mejoras" },
                { "codigo": "MP8.05.02", "descripcion": "Acciones preventivas y correctivas" }
            ],
            instrucciones: [
                { "codigo": "MI4.02.01.01", "descripcion": "Archivo general" },
                { "codigo": "MI5.04.02.02", "descripcion": "Plan de emergencias" },
                { "codigo": "MI5.05.01.01", "descripcion": "Sistema de telecomunicaciones" },
                { "codigo": "MI6.02.01.02", "descripcion": "Reglamento interno" },
                { "codigo": "MI7.02.01.02", "descripcion": "Costos estándares" },
                { "codigo": "MI7.03.01.01", "descripcion": "Criterios generales para el diseño" },
                { "codigo": "MI7.05.01.10", "descripcion": "Distancias dieléctricas en equipos e instalaciones eléctricas" },
                { "codigo": "MI7.05.01.22", "descripcion": "Montaje de celdas de media tensión" },
                { "codigo": "MI7.05.01.25", "descripcion": "Puesta a tierra de estaciones transformadoras" },
                { "codigo": "MI7.05.01.26", "descripcion": "Tendido de cables en general" },
                { "codigo": "MI7.05.01.27", "descripcion": "Tendido de cable subterráneo en la vía pública" },
                { "codigo": "MI7.05.01.43", "descripcion": "Instalaciones eléctricas obra “110 Nuevas escuelas 2001”" },
                { "codigo": "MI7.05.01.44", "descripcion": "Acercamientos eléctricos en BT y MT" },
                { "codigo": "MI7.05.01.49", "descripcion": "Ejecución de estaciones transformadoras" },
                { "codigo": "MI7.05.01.50", "descripcion": "Replanteo" },
                { "codigo": "MI7.05.01.62", "descripcion": "Pruebas y puesta en marcha de E.T." },
                { "codigo": "MI7.05.01.69", "descripcion": "Puesta en servicio de líneas aéreas" },
                { "codigo": "MI7.05.01.70", "descripcion": "Medición de parámetros y ensayos de líneas aéreas" },
                { "codigo": "MI8.02.04.02", "descripcion": "Instrucción de autoinspección para fabricación, obras y servicio posventa" },
                { "codigo": "MI8.02.04.03", "descripcion": "Instrucción de proceso de pruebas funcionales" },
                { "codigo": "MI8.02.04.04", "descripcion": "Instrucción de inspección y ensayos finales" },
                { "codigo": "MI8.04.01.04", "descripcion": "Rendición de viajes. Asignación de mano de obra" },
                { "codigo": "MI8.04.02.06", "descripcion": "Elaboración de estadísticas en el área ingeniería" }],
            funciones: [
                { "codigo": "EI 008-08", "descripcion": "Gerente de obras y servicios" },
                { "codigo": "EI 008-07", "descripcion": "Subgerente de ingeniería" },
                { "codigo": "EI 008-11", "descripcion": "Encargado / inspector de calidad" },
                { "codigo": "EI 008-12", "descripcion": "Responsable del proyecto" },
                { "codigo": "EI 008-13", "descripcion": "Proyectista" },
                { "codigo": "EI 008-17", "descripcion": "Comercial responsable del presupuesto / contrato" },
                { "codigo": "EI 008-20", "descripcion": "Jefe de obras de construcción, instalación y montaje" },
                { "codigo": "EI 008-26", "descripcion": "Responsable de estadísticas" },
                { "codigo": "EI 008-37", "descripcion": "Inspector designado" },
                { "codigo": "EI 008-40", "descripcion": "Inspectores de calidad" },
                { "codigo": "EI 008-63", "descripcion": "Coordinador de obras" },
                { "codigo": "EI 008-65", "descripcion": "Responsable de archivos" }
            ],
            formularios: [{ "codigo": "EI 002", "descripcion": "Política de la calidad, medio ambiente, y seguridad y salud ocupacional" },
            { "codigo": "EI 004", "descripcion": "Organigrama de Electroingenieria ICS SA" },
            { "codigo": "EI 025a", "descripcion": "Planilla de características técnicas (Media tensión)" },
            { "codigo": "EI 025b", "descripcion": "Planilla de características técnicas" },
            { "codigo": "EI 026", "descripcion": "Planilla de solicitud / reemplazo / anulación de materiales (sistema informático)" },
            { "codigo": "EI 027", "descripcion": "Planilla control de documentos" },
            { "codigo": "EI 028", "descripcion": "Formato planos ingeniería / ing. de producto A4" },
            { "codigo": "EI 029", "descripcion": "Formato planos ingeniería / ing. de producto A3" },
            { "codigo": "EI 030", "descripcion": "Formato planos ingeniería / ing. de producto A2" },
            { "codigo": "EI 031", "descripcion": "Cronograma de ejecución de O.T." },
            { "codigo": "EI 032", "descripcion": "Padrón de órdenes de trabajo" },
            { "codigo": "EI 033", "descripcion": "Formato planos ingeniería / ing. de producto A1" },
            { "codigo": "EI 040", "descripcion": "Planilla de características del contrato" },
            { "codigo": "EI 044", "descripcion": "Informe de no conformidad" },
            { "codigo": "EI 057", "descripcion": "Registro de autoinspección de procesos" },
            { "codigo": "EI 062", "descripcion": "Planilla de horas de ingeniería / ingeniería de producto" },
            { "codigo": "EI 063", "descripcion": "Constancia de ensayos" },
            { "codigo": "EI 064", "descripcion": "Protocolo de ensayo" },
            { "codigo": "EI 089", "descripcion": "Registro de capacitación" },
            { "codigo": "EI 090", "descripcion": "Pedido de servicio posventa" },
            { "codigo": "EI 091", "descripcion": "Ejecución de servicio posventa" },
            { "codigo": "EI 105", "descripcion": "Registro de Capacitación Externa" },
            { "codigo": "EI 112", "descripcion": "Planilla de revisión / verificación / validación del diseño" },
            { "codigo": "EI 113", "descripcion": "Informe / Minuta de reunión…" },
            { "codigo": "EI 128", "descripcion": "Rendición de gastos de viaje" },
            { "codigo": "EI 129", "descripcion": "Rendición de fondos fijos transitorios" },
            { "codigo": "EI 130", "descripcion": "Asignación de mano de obra" }],
            manuales: [{ "codigo": "EI 400", "descripcion": "Manual de montaje y puesta en servicio - CEISA 90" },
            { "codigo": "EI 401", "descripcion": "Manual de montaje y puesta en servicio - Celda CEISA 21" },
            { "codigo": "EI 402", "descripcion": "Características generales y particulares de los centros prefabricados en hormigón" },
            { "codigo": "EI 403", "descripcion": "Centros prefabricados en hormigón: Condiciones de seguridad" },
            { "codigo": "EI 404", "descripcion": "Manual reducido del SGI" },
            { "codigo": "EI 405", "descripcion": "Legislación para subcontratistas" }]
        };
    }
};
</script>